import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock } from "lucide-react";
import useSeo from "@/lib/useSeo";
import MarketingShell from "@/components/marketing/MarketingShell";
import { RESOURCES } from "./resourcesData";

export default function Resources() {
  useSeo({
    title: "Resources — change management, in plain English | ChangeOS",
    description: "Short, practical reads on the people side of change: why you need a change plan, and how practitioners run a client change in ChangeOS and hand it over cleanly.",
    path: "/resources",
  });
  return (
    <MarketingShell>
      <section className="pp-grid-bg border-b border-border-soft">
        <div className="max-w-6xl mx-auto px-6 pt-20 pb-16">
          <div className="pp-overline">Resources</div>
          <h1 className="font-head font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-3 max-w-3xl">The people side of change, in plain English</h1>
          <p className="text-lg text-subtle mt-5 max-w-2xl">Short, practical reads — whether you've just been handed a change and don't know where to start, or you run change for a living.</p>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-20" data-testid="resources-index">
        <div className="grid md:grid-cols-2 gap-6">
          {RESOURCES.map((r) => (
            <Link key={r.slug} to={`/resources/${r.slug}`} data-testid={`resource-card-${r.slug}`} className="group pp-card pp-card-hover p-8 flex flex-col">
              <div className="w-10 h-10 rounded-xl bg-accent-50 text-accent-700 flex items-center justify-center group-hover:bg-ink group-hover:text-on-dark transition-colors"><BookOpen size={20} /></div>
              <div className="font-mono text-[11px] text-accent-700 mt-5">{r.audience}</div>
              <h2 className="font-head text-2xl font-extrabold tracking-tight mt-1">{r.title}</h2>
              <p className="text-subtle text-sm mt-3 leading-relaxed flex-1">{r.description}</p>
              <div className="mt-5 flex items-center justify-between text-sm">
                <span className="inline-flex items-center gap-1.5 text-muted-foreground"><Clock size={14} /> {r.minutes} min read</span>
                <span className="inline-flex items-center gap-1.5 font-bold text-body group-hover:text-accent-600 transition-colors">Read <ArrowRight size={15} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
